"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enforceInvalidCharactersOnHTML = enforceInvalidCharactersOnHTML;
exports.enforceCharLengthOnHTML = enforceCharLengthOnHTML;
exports.enforceTextTransformOnHTML = enforceTextTransformOnHTML;
const getInvalidCharactersForFoilStamp_1 = require("../../utils/getInvalidCharactersForFoilStamp");
const transferUserDataForLayersHelper_1 = require("./transferUserDataForLayersHelper");
function enforceInvalidCharactersOnHTML(html, newLayerFontSizeInPt) {
  const invalidCharsRegex = (0, getInvalidCharactersForFoilStamp_1.getInvalidCharactersForFoilStamp)(newLayerFontSizeInPt);
  if (!invalidCharsRegex) {
    return html;
  }
  const decodedHtml = (0, transferUserDataForLayersHelper_1.decodeHtmlStringIntoString)(html);
  const validDecodedHtml = (0, getInvalidCharactersForFoilStamp_1.removeInvalidCharactersInHtml)(decodedHtml, newLayerFontSizeInPt);
  return (0, transferUserDataForLayersHelper_1.encodeStringIntoHtmlString)(validDecodedHtml);
}
function enforceCharLengthOnHTML(html, charLength) {
  let decodedHtml = (0, transferUserDataForLayersHelper_1.decodeHtmlStringIntoString)(html);
  //get character count without HTML tags
  const characterCountOfDecodedRawText = decodedHtml.replace(/<[^>]*>/g, '').length;
  //remove the last non-tag character each iteration until we are at the character length restriction
  let numOfCharactersToRemove = characterCountOfDecodedRawText - charLength;
  while (numOfCharactersToRemove > 0) {
    const htmlWithoutTags = decodedHtml.replace(/<[^>]*>/g, '');
    if (!(htmlWithoutTags === null || htmlWithoutTags === void 0 ? void 0 : htmlWithoutTags.length)) {
      break;
    }
    const lastNonTagChar = htmlWithoutTags[htmlWithoutTags.length - 1];
    const indexOfLastNonTagChar = decodedHtml.lastIndexOf(lastNonTagChar);
    if (indexOfLastNonTagChar < 0) {
      break;
    }
    decodedHtml = decodedHtml.substring(0, indexOfLastNonTagChar) + decodedHtml.substring(indexOfLastNonTagChar + 1);
    numOfCharactersToRemove--;
  }
  let match;
  while ((match = /<([^>]*)><\/\1>/g.exec(decodedHtml)) !== null) {
    decodedHtml = decodedHtml.replace(match[0], '');
  }
  return (0, transferUserDataForLayersHelper_1.encodeStringIntoHtmlString)(decodedHtml);
}
function enforceTextTransformOnHTML(html) {
  const resultHtml = html;
  const regex = /(<\/?[a-z]+>)/g;
  let result = '';
  let match;
  let currentIndex = 0;
  while ((match = regex.exec(resultHtml)) !== null) {
    const tagIndex = match.index;
    const tagLength = match[0].length;
    // Process the content between the tags and convert it to uppercase
    if (tagIndex > currentIndex) {
      const content = resultHtml.substring(currentIndex, tagIndex);
      result += content.toUpperCase();
    }
    // Append the matched tag as is
    result += resultHtml.substring(tagIndex, tagIndex + tagLength);
    currentIndex = tagIndex + tagLength;
  }
  // Process any remaining content after the last tag
  if (currentIndex < resultHtml.length) {
    const content = resultHtml.substring(currentIndex);
    result += content.toUpperCase();
  }
  return result;
}